import { Injectable, signal } from '@angular/core';
import { Bill } from '../models/billing.model';

@Injectable({
  providedIn: 'root'
})
export class BillingService {
  private bills = signal<Bill[]>([]);

  constructor() {
    // Initialize with mock data
    this.bills.set([
      {
        id: '1',
        patientId: '1',
        patientName: 'Alice Johnson',
        billNumber: 'BL-2024-001',
        date: new Date(),
        dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
        items: [
          {
            description: 'Consultation Fee',
            quantity: 1,
            unitPrice: 150,
            total: 150
          },
          {
            description: 'Lab Tests',
            quantity: 1,
            unitPrice: 200,
            total: 200
          }
        ],
        subtotal: 350,
        tax: 35,
        discount: 0,
        total: 385,
        status: 'Pending',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ]);
  }

  getBills() {
    return this.bills.asReadonly();
  }

  getBillById(id: string): Bill | undefined {
    return this.bills().find(b => b.id === id);
  }

  getBillsByPatient(patientId: string): Bill[] {
    return this.bills().filter(b => b.patientId === patientId);
  }

  addBill(bill: Omit<Bill, 'id' | 'createdAt' | 'updatedAt'>): Bill {
    const newBill: Bill = {
      ...bill,
      id: Date.now().toString(),
      createdAt: new Date(),
      updatedAt: new Date()
    };
    this.bills.update(bills => [...bills, newBill]);
    return newBill;
  }

  updateBill(id: string, updates: Partial<Bill>): void {
    this.bills.update(bills =>
      bills.map(b =>
        b.id === id ? { ...b, ...updates, updatedAt: new Date() } : b
      )
    );
  }

  deleteBill(id: string): void {
    this.bills.update(bills => bills.filter(b => b.id !== id));
  }

  markAsPaid(id: string, paymentMethod: Bill['paymentMethod'], paymentDate: Date): void {
    this.updateBill(id, {
      status: 'Paid',
      paymentMethod,
      paymentDate
    });
  }
}

